var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 281,
    viewBox: "0 0 423 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1061_54246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 31,
    width: 317,
    height: 119
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.0762L168.877 149.14H316.07L217.841 83.6387L0 31.0762Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1061_54246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0281 -73.1153L-39.0303 134.141L276.917 252.534L354.975 45.2786L39.0281 -73.1153Z",
    fill: "#29171C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1061_54246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 149,
    width: 237,
    height: 132
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.877 149.139L80.0293 280.071L316.069 149.139H168.877Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1061_54246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.607 45.7587L22.4453 183.203L141.544 383.361L373.706 245.916L254.607 45.7587Z",
    fill: "#29171C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1061_54246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 8,
    width: 140,
    height: 104
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.432 12.5698L278.511 111.515L212.157 8.91797L139.432 12.5698Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1061_54246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.114 -60.3251L87.9844 61.6562L210.754 180.951L329.884 58.9692L207.114 -60.3251Z",
    fill: "#29171C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1061_54246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 155,
    width: 144,
    height: 84
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.488 238.745L297.431 196.944L316.686 155.705L173.488 238.745Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1061_54246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.803 84.8059L132.289 191.486L235.467 309.379L357.98 202.698L254.803 84.8059Z",
    fill: "#29171C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1061_54246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 289,
    y: 101,
    width: 134,
    height: 58
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289.599 101.475L344.213 138.904L324.465 158.075H422.289H422.324L366.882 114.027L289.599 101.475Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1061_54246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.147 96.8227L287.587 101.557L289.75 162.737L424.31 158.003L422.147 96.8227Z",
    fill: "#29171C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1061_54246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 0,
    width: 122,
    height: 53
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8923 23.4023L163.438 52.4927L89.6746 0L42.8923 23.4023Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1061_54246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0122 -43.8687L23.6843 44.2246L144.34 96.4549L182.668 8.36156L62.0122 -43.8687Z",
    fill: "#29171C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1061_54246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 298,
    y: 178,
    width: 21,
    height: 37
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M298.962 214.606L318.78 207.303L315.876 178.354L298.962 214.606Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1061_54246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.475 173.793L289.699 212.551L317.463 220.231L328.239 181.473L300.475 173.793Z",
    fill: "#29171C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFooter);
export default __webpack_public_path__ + "static/media/bg-footer.7f66f945718e82945fa4ba196d27b4cb.svg";
export { ForwardRef as ReactComponent };